import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSubscribers,
  resetState,
  sendMarketingEmail,
  deleteSubscriberById,
} from "../features/auth/authSlice";
import { AiFillDelete } from "react-icons/ai";
import CustomModal from "../components/CustomModal";

const Subscribers = () => {
  const dispatch = useDispatch();
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [subscriberId, setSubscriberId] = useState("");

  useEffect(() => {
    dispatch(resetState());
    dispatch(getAllSubscribers());
  }, [dispatch]);

  const subscribers = useSelector((state) => state.auth.subscribers);

  const showModal = (id) => {
    setOpen(true);
    setSubscriberId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleDeleteSubscriber = (id) => {
    dispatch(deleteSubscriberById(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getAllSubscribers());
    }, 100);
  };

  const handleSendEmail = () => {
    dispatch(
      sendMarketingEmail({
        subject,
        message,
        html: `<p>${message}</p>`,
      })
    );
  };

  const generateData = (subs) =>
    subs.map((sub, index) => ({
      key: index + 1,
      email: sub.email,
      action: (
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(sub._id)}
        >
          <AiFillDelete />
        </button>
      ),
    }));

  const columns = [
    { title: "SNo", dataIndex: "key" },
    { title: "Email", dataIndex: "email" },
    { title: "Action", dataIndex: "action" }, // Delete button column
  ];

  return (
    <div>
      <h3 className="mb-4 title">Newsletter Subscribers</h3>

      <Table columns={columns} dataSource={generateData(subscribers)} />

      {/* ---------------- Email Marketing Section ---------------- */}
      <div className="mt-5 p-4 card">
        <h4>Send Marketing Email</h4>

        <label>Subject</label>
        <input
          type="text"
          className="form-control mb-3"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Enter email subject"
        />

        <label>Message</label>
        <textarea
          className="form-control mb-3"
          rows="5"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write your marketing message..."
        ></textarea>

        <button className="btn btn-primary" onClick={handleSendEmail}>
          Send Marketing Email
        </button>
      </div>

      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => handleDeleteSubscriber(subscriberId)}
        title="Are you sure you want to delete this subscriber?"
      />
    </div>
  );
};

export default Subscribers;
